const QUERY_LIMIT = 20;

export const pageToQuery = (page: number, customPageLimit?: number): { limit: number, skip: number } => {
  const queryLimit = customPageLimit || QUERY_LIMIT;
  const limit = queryLimit;
  const skip = page * queryLimit - queryLimit;

  return {
    skip,
    limit,
  };
};
